module.exports = __webpack_public_path__ + "media/images/talent/case2-img01-e9dc22888bd2c2ccea0ecbcc85d68b5c.png";